import type { GoldenRow } from "../types/goldenRow";

/** Serialises a golden row as a single NDJSON line (no pretty-print). */
export function formatGoldenNdjson(row: GoldenRow): string {
  return JSON.stringify(row);
}
